import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

type PricePoint = {
  date: string   // Date in YYYY-MM-DD format
  price: number  // Price in USD
  volume: number // Trading volume in USD
}
type CoinGeckoChartResponse = {
  prices: [number, number][]        // [timestamp, price]
  total_volumes: [number, number][] // [timestamp, volume]
}

export const coingeckoApi = createApi({
  reducerPath: 'coingeckoApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://api.coingecko.com/api/v3/' }),
  endpoints: (builder) => ({
    // Fetch ZNX price history with volume data
    getZenexChart: builder.query<PricePoint[], number | string>({
      // `days` can be a number or 'max', controls chart length
      query: (days) => `coins/zenex/market_chart?vs_currency=usd&days=${days}`,
      transformResponse: (res: CoinGeckoChartResponse): PricePoint[] => {
        const prices = res.prices ?? []
        const vols = res.total_volumes ?? []
        return prices.map(([ts, price], i) => {
          const date = new Date(ts).toISOString().split('T')[0] // Format timestamp to date
          // In CoinGecko API, each entry is [timestamp, value]. More info: https://docs.coingecko.com/reference/coins-id-market-chart
          // For total_volumes: index 0 = timestamp, index 1 = volume value
          // Here we take the volume value from the matching index in vols[]
          const volume = vols[i]?.[1] ?? 0
          return { date, price, volume }
        })
      },
    }),
  }),
})

export const { useGetZenexChartQuery } = coingeckoApi
